import * as React from 'react';

import { localization } from '../../../shared/localization/localization';
import { ILine } from '../tron-editor-api';
import { StrokePicker } from './stroke-picker.component';
import { IntegerInput } from 'src/App/shared/components/integer-input.component';

export interface ILogoEditorLineSettingsProps {
    lineObj: ILine;
    recentColors: string[];
    logoColors: string[];
    onSetColor(type:string, color:string):void;
    onStrokeWidthChange(width: number): void;
    addPresetColor:(color: string) => void;
}

interface IState {}

export class LogoEditorLineSettings extends React.Component<ILogoEditorLineSettingsProps, IState> {
    constructor(props: ILogoEditorLineSettingsProps) {
        super(props);
        this.state = { strokeWidth: 0}
    }

    public render() {
        return (
            <div className="line-properties-root">
                <StrokePicker
                    selectedColor={this.props.lineObj.StrokeColor}
                    recentColors={this.props.recentColors}
                    logoColors={this.props.logoColors}
                    hint={localization.editorLoc.logoEditorContent.toolTips.lineStrokeColor}
                    onColorChanged={(color) => this.props.onSetColor("stroke", color)}
                    addPresetColor={this.props.addPresetColor}
                />
                <IntegerInput
                    initialValue={this.props.lineObj.StrokeWidth}
                    minValue={1}
                    maxValue={20}
                    hint={localization.editorLoc.logoEditorContent.toolTips.lineStrokeWidth}
                    onValueSet={value => this.props.onStrokeWidthChange(value)}
                />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/App/logo-app/logo-editor/logo-editor-controls/logo-editor-line-settings.component.tsx